import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface MessageViewerUnreadProps {
  /** When true, the unread indicator will not be displayed. */
  isAutoResponse?: boolean;
  /** When false-y, the unread indicator will not be displayed. */
  isNewUnread?: boolean;
  /** When true, the unread indicator will not be displayed. */
  isUserAuthor?: boolean;
}

/*
 * Style.
 */

const StyledUnreadDiv = styled.div`
  padding: 0 4px;
  min-height: 16px;
  display: flex;
  align-items: center;

  border-radius: 9999px;
  background-color: ${(p) => p.theme.palette.blue.shade40};

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.bold};
  text-transform: uppercase;
`;

/*
 * Component.
 */

export const MessageViewerUnread: FC<MessageViewerUnreadProps> = (props) => {
  if (!props.isNewUnread || props.isUserAuthor || props.isAutoResponse) {
    return null;
  }

  return (
    <StyledUnreadDiv>
      <Trans id="message-detail-new">New</Trans>
    </StyledUnreadDiv>
  );
};
